/**
 * @generated SignedSource<<45b8ab22ce54b473b168dc45c90b8949>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type defaultSectionQuery$data = {
  readonly asiaQueue?: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly chinaFutureTechQueue?: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly chinaScienceQueue?: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly commentQueue: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly section: {
    readonly advertZone: string | null | undefined;
    readonly entityId: string;
    readonly name: string;
    readonly subSections: {
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"entityOnelineMenuLiteQueueItemsEdge">;
        }>;
      } | null | undefined;
      readonly settings: unknown | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"entityFollowButtonBase" | "sectionDescriptionSection" | "sectionTermLogoSection">;
  };
  readonly sectionEditorPicks?: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"sectionEditorPicksQueue">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly spotlightQueue: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly topStories: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge" | "oneSectionTopWidgetQueue" | "topStoriesBlockQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly twiaQueue?: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"hooksSectionWidgetQuery" | "sectionNewsletterWidgetQuery" | "sectionSpotlightQuery">;
  readonly " $fragmentType": "defaultSectionQuery";
};
export type defaultSectionQuery$key = {
  readonly " $data"?: defaultSectionQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"defaultSectionQuery">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "applicationId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentHarrySectionIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentQueueLimit"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentQueueName"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dailyPulseTypeUuId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "focusQueueName"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "highlightQueueName"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeAsiaDiscoveryWidget"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeChinaFutureTechDiscoveryWidget"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeChinaScienceDiscoveryWidget"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeComment"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeFocusArticle"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeMostPopular"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeMultimedia"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeOpenQuestionsSeriesDiscoveryWidget"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includePlus"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeThisWeekInAsiaDiscovery"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeTrendingTopics"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mostPopularQueueName"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "multimediaQueueName"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "plusNewsAgendaEndDate"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "plusNewsAgendaStartDate"
},
v22 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "plusNewsAgendaTypes"
},
v23 = {
  "defaultValue": ([]/*: any*/),
  "kind": "LocalArgument",
  "name": "scmpPlusPaywallTypeIds"
},
v24 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "trendingTopicsQueueName"
},
v25 = [
  {
    "kind": "Variable",
    "name": "entityId",
    "variableName": "entityId"
  }
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "version",
      "value": 2
    }
  ],
  "kind": "ScalarField",
  "name": "advertZone",
  "storageKey": "advertZone(version:2)"
},
v28 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge"
},
v29 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 6
  }
],
v30 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      (v28/*: any*/)
    ],
    "storageKey": null
  }
],
v31 = [
  {
    "alias": null,
    "args": (v29/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": (v30/*: any*/),
    "storageKey": "items(first:6)"
  }
],
v32 = {
  "kind": "Variable",
  "name": "commentHarrySectionIds",
  "variableName": "commentHarrySectionIds"
},
v33 = {
  "kind": "Variable",
  "name": "commentQueueName",
  "variableName": "commentQueueName"
},
v34 = {
  "kind": "Variable",
  "name": "scmpPlusPaywallTypeIds",
  "variableName": "scmpPlusPaywallTypeIds"
},
v35 = {
  "kind": "Variable",
  "name": "mostPopularQueueName",
  "variableName": "mostPopularQueueName"
},
v36 = {
  "kind": "Variable",
  "name": "multimediaQueueName",
  "variableName": "multimediaQueueName"
},
v37 = {
  "kind": "Variable",
  "name": "trendingTopicsQueueName",
  "variableName": "trendingTopicsQueueName"
},
v38 = {
  "kind": "Variable",
  "name": "applicationId",
  "variableName": "applicationId"
},
v39 = {
  "kind": "Variable",
  "name": "dailyPulseTypeUuId",
  "variableName": "dailyPulseTypeUuId"
},
v40 = {
  "kind": "Variable",
  "name": "highlightQueueName",
  "variableName": "highlightQueueName"
},
v41 = {
  "kind": "Variable",
  "name": "plusNewsAgendaEndDate",
  "variableName": "plusNewsAgendaEndDate"
},
v42 = {
  "kind": "Variable",
  "name": "plusNewsAgendaStartDate",
  "variableName": "plusNewsAgendaStartDate"
},
v43 = {
  "kind": "Variable",
  "name": "plusNewsAgendaTypes",
  "variableName": "plusNewsAgendaTypes"
},
v44 = {
  "kind": "Variable",
  "name": "focusQueueName",
  "variableName": "focusQueueName"
};
return {
  "argumentDefinitions": [
    (v0/*: any*/),
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "articlesQueueName"
    },
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "editorPicksQueueName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "entityId"
    },
    (v5/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeEditorPicks"
    },
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/),
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sectionSpotlightQueueName"
    },
    (v24/*: any*/)
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "defaultSectionQuery",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": (v25/*: any*/),
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "section",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        (v26/*: any*/),
        (v27/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Queue",
          "kind": "LinkedField",
          "name": "subSections",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemConnection",
              "kind": "LinkedField",
              "name": "items",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "QueueItemsEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "entityOnelineMenuLiteQueueItemsEdge"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "settings",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "sectionTermLogoSection"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "sectionDescriptionSection"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "entityFollowButtonBase"
        }
      ],
      "storageKey": null
    },
    {
      "alias": "topStories",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "name",
              "variableName": "articlesQueueName"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 17
            }
          ],
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "oneSectionTopWidgetQueue"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "topStoriesBlockQueueItemsEdge"
                },
                (v28/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": "items(first:17)"
        }
      ],
      "storageKey": null
    },
    {
      "condition": "includeEditorPicks",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "sectionEditorPicks",
          "args": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "name",
                  "variableName": "editorPicksQueueName"
                }
              ],
              "kind": "ObjectValue",
              "name": "filter"
            }
          ],
          "concreteType": "Queue",
          "kind": "LinkedField",
          "name": "queue",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": (v29/*: any*/),
              "concreteType": "QueueItemConnection",
              "kind": "LinkedField",
              "name": "items",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "QueueItemsEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "sectionEditorPicksQueue"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "items(first:6)"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": "spotlightQueue",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "name",
              "variableName": "sectionSpotlightQueueName"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 4
            }
          ],
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": (v30/*: any*/),
          "storageKey": "items(first:4)"
        }
      ],
      "storageKey": null
    },
    {
      "alias": "commentQueue",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "name",
              "variableName": "commentQueueName"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "commentQueueLimit"
            }
          ],
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": (v30/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "includeAsiaDiscoveryWidget",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "asiaQueue",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "name": "section_top_3"
              }
            }
          ],
          "concreteType": "Queue",
          "kind": "LinkedField",
          "name": "queue",
          "plural": false,
          "selections": (v31/*: any*/),
          "storageKey": "queue(filter:{\"name\":\"section_top_3\"})"
        }
      ]
    },
    {
      "condition": "includeChinaFutureTechDiscoveryWidget",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "chinaFutureTechQueue",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "name": "section_top_519735"
              }
            }
          ],
          "concreteType": "Queue",
          "kind": "LinkedField",
          "name": "queue",
          "plural": false,
          "selections": (v31/*: any*/),
          "storageKey": "queue(filter:{\"name\":\"section_top_519735\"})"
        }
      ]
    },
    {
      "condition": "includeChinaScienceDiscoveryWidget",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "chinaScienceQueue",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "name": "section_top_328475"
              }
            }
          ],
          "concreteType": "Queue",
          "kind": "LinkedField",
          "name": "queue",
          "plural": false,
          "selections": (v31/*: any*/),
          "storageKey": "queue(filter:{\"name\":\"section_top_328475\"})"
        }
      ]
    },
    {
      "condition": "includeThisWeekInAsiaDiscovery",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "twiaQueue",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "name": "section_top_323045"
              }
            }
          ],
          "concreteType": "Queue",
          "kind": "LinkedField",
          "name": "queue",
          "plural": false,
          "selections": (v31/*: any*/),
          "storageKey": "queue(filter:{\"name\":\"section_top_323045\"})"
        }
      ]
    },
    {
      "args": (v25/*: any*/),
      "kind": "FragmentSpread",
      "name": "sectionNewsletterWidgetQuery"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "sectionSpotlightQueueName",
          "variableName": "sectionSpotlightQueueName"
        }
      ],
      "kind": "FragmentSpread",
      "name": "sectionSpotlightQuery"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "hooksSectionWidgetQuery",
      "selections": [
        {
          "alias": "advertConfig",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "entityId": "scmp_pwa_advert_campaign"
              }
            }
          ],
          "concreteType": "AppConfig",
          "kind": "LinkedField",
          "name": "appConfig",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "json",
              "storageKey": null
            }
          ],
          "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_advert_campaign\"})"
        },
        {
          "alias": null,
          "args": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "entityId",
                  "variableName": "sectionId"
                }
              ],
              "kind": "ObjectValue",
              "name": "filter"
            }
          ],
          "concreteType": "Section",
          "kind": "LinkedField",
          "name": "section",
          "plural": false,
          "selections": [
            (v26/*: any*/),
            (v27/*: any*/)
          ],
          "storageKey": null
        },
        {
          "condition": "includeThisWeekInAsiaDiscovery",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "thisWeekInAsiaDiscoveryWidgetQuery"
            }
          ]
        },
        {
          "condition": "includeComment",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": [
                (v32/*: any*/),
                {
                  "kind": "Variable",
                  "name": "commentLimit",
                  "variableName": "commentQueueLimit"
                },
                (v33/*: any*/),
                (v34/*: any*/),
                {
                  "kind": "Literal",
                  "name": "withHarrysView",
                  "value": false
                }
              ],
              "kind": "FragmentSpread",
              "name": "commentQueueQuery"
            }
          ]
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "discoveryWidgetPostMagazineQueueQuery"
        },
        {
          "condition": "includeMostPopular",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": [
                (v35/*: any*/)
              ],
              "kind": "FragmentSpread",
              "name": "mostPopularQueueQuery"
            }
          ]
        },
        {
          "condition": "includeMultimedia",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": [
                (v36/*: any*/)
              ],
              "kind": "FragmentSpread",
              "name": "multimediaQuery"
            }
          ]
        },
        {
          "condition": "includeTrendingTopics",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": [
                (v37/*: any*/)
              ],
              "kind": "FragmentSpread",
              "name": "trendingTopicTopic"
            }
          ]
        },
        {
          "condition": "includePlus",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": [
                (v38/*: any*/),
                (v39/*: any*/),
                (v40/*: any*/),
                (v41/*: any*/),
                (v42/*: any*/),
                (v43/*: any*/)
              ],
              "kind": "FragmentSpread",
              "name": "plusWidgetQuery"
            }
          ]
        },
        {
          "condition": "includeAsiaDiscoveryWidget",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "asiaDiscoveryWidgetQuery"
            }
          ]
        },
        {
          "condition": "includeChinaScienceDiscoveryWidget",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "chinaScienceDiscoveryWidgetQuery"
            }
          ]
        },
        {
          "condition": "includeChinaFutureTechDiscoveryWidget",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "chinaFutureTechDiscoveryWidgetQuery"
            }
          ]
        },
        {
          "condition": "includeFocusArticle",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": [
                (v44/*: any*/)
              ],
              "kind": "FragmentSpread",
              "name": "focusArticleHomeFocusArticleQuery"
            }
          ]
        },
        {
          "condition": "includeOpenQuestionsSeriesDiscoveryWidget",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": [
                (v34/*: any*/)
              ],
              "kind": "FragmentSpread",
              "name": "openQuestionsSeriesDiscoveryWidgetQuery"
            }
          ]
        }
      ],
      "args": [
        (v38/*: any*/),
        (v32/*: any*/),
        {
          "kind": "Variable",
          "name": "commentQueueLimit",
          "variableName": "commentQueueLimit"
        },
        (v33/*: any*/),
        (v39/*: any*/),
        (v44/*: any*/),
        (v40/*: any*/),
        {
          "kind": "Variable",
          "name": "includeAsiaDiscoveryWidget",
          "variableName": "includeAsiaDiscoveryWidget"
        },
        {
          "kind": "Variable",
          "name": "includeChinaFutureTechDiscoveryWidget",
          "variableName": "includeChinaFutureTechDiscoveryWidget"
        },
        {
          "kind": "Variable",
          "name": "includeChinaScienceDiscoveryWidget",
          "variableName": "includeChinaScienceDiscoveryWidget"
        },
        {
          "kind": "Variable",
          "name": "includeComment",
          "variableName": "includeComment"
        },
        {
          "kind": "Variable",
          "name": "includeFocusArticle",
          "variableName": "includeFocusArticle"
        },
        {
          "kind": "Variable",
          "name": "includeMostPopular",
          "variableName": "includeMostPopular"
        },
        {
          "kind": "Variable",
          "name": "includeMultimedia",
          "variableName": "includeMultimedia"
        },
        {
          "kind": "Variable",
          "name": "includeOpenQuestionsSeriesDiscoveryWidget",
          "variableName": "includeOpenQuestionsSeriesDiscoveryWidget"
        },
        {
          "kind": "Variable",
          "name": "includePlus",
          "variableName": "includePlus"
        },
        {
          "kind": "Variable",
          "name": "includeThisWeekInAsiaDiscovery",
          "variableName": "includeThisWeekInAsiaDiscovery"
        },
        {
          "kind": "Variable",
          "name": "includeTrendingTopics",
          "variableName": "includeTrendingTopics"
        },
        (v35/*: any*/),
        (v36/*: any*/),
        (v41/*: any*/),
        (v42/*: any*/),
        (v43/*: any*/),
        (v34/*: any*/),
        {
          "kind": "Variable",
          "name": "sectionId",
          "variableName": "entityId"
        },
        (v37/*: any*/)
      ],
      "argumentDefinitions": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/),
        (v7/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        (v18/*: any*/),
        (v19/*: any*/),
        (v20/*: any*/),
        (v21/*: any*/),
        (v22/*: any*/),
        (v23/*: any*/),
        {
          "defaultValue": null,
          "kind": "LocalArgument",
          "name": "sectionId"
        },
        (v24/*: any*/)
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "8f2f8de99ca7bcaf34d4f1b93359b6d1";

export default node;
